import React from 'react';
import UnderHeader from '../../../shared/header/under-header';
import ComplaintsContent from './components/complaints-content';
import Head from '../../../shared/head';

const Complaints = () => {
    const heroImageContent = (
    <div id="hero-footer" className="hero-footer">
        <div className="row">
        <h1 className="brandon-light">Consumer Complaints</h1>                        
        </div>
    </div>); 
    return(
        <>
            <Head title={`Loanpal ${window.location.pathname.split('/')[1]}`} />
            <UnderHeader                
                image="img-container-hero-footer-pages"                                
                bgColor="grey-header"
                border=""
                heroImageContent={heroImageContent}
                showDIYSlideshow={false}
                showSlideshowMovie={false}
            />
            <ComplaintsContent />                
        </>                
    )
}

export default Complaints;